/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Guess_Country_PromptInputs */

const bn_game_guess_country_prompt = /** @type {(inputs: Game_Guess_Country_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হাইলাইট দেশ অনুমান.`)
};

const de_game_guess_country_prompt = /** @type {(inputs: Game_Guess_Country_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erraten Sie das markierte Land.`)
};

const el_game_guess_country_prompt = /** @type {(inputs: Game_Guess_Country_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μαντέψτε την επισημασμένη χώρα.`)
};

const en_game_guess_country_prompt = /** @type {(inputs: Game_Guess_Country_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guess the highlighted country.`)
};

const es_game_guess_country_prompt = /** @type {(inputs: Game_Guess_Country_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adivina el país resaltado.`)
};

const fr_game_guess_country_prompt = /** @type {(inputs: Game_Guess_Country_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devinez le pays surligné.`)
};

const hi_game_guess_country_prompt = /** @type {(inputs: Game_Guess_Country_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाइलाइट किए गए देश का अनुमान लगाएं.`)
};

const hu_game_guess_country_prompt = /** @type {(inputs: Game_Guess_Country_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Találd meg a kiemelt országot.`)
};

const id_game_guess_country_prompt = /** @type {(inputs: Game_Guess_Country_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tebak negara yang disorot.`)
};

const it_game_guess_country_prompt = /** @type {(inputs: Game_Guess_Country_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indovina il paese evidenziato.`)
};

const ja_game_guess_country_prompt = /** @type {(inputs: Game_Guess_Country_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ハイライト表示されている国を推測してください。`)
};

const ko_game_guess_country_prompt = /** @type {(inputs: Game_Guess_Country_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`강조 표시된 국가를 맞춰보세요.`)
};

const nl_game_guess_country_prompt = /** @type {(inputs: Game_Guess_Country_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raad het gemarkeerde land.`)
};

const pl_game_guess_country_prompt = /** @type {(inputs: Game_Guess_Country_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zgadnij podświetlony kraj.`)
};

const pt_game_guess_country_prompt = /** @type {(inputs: Game_Guess_Country_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adivinhe o país destacado.`)
};

const ru_game_guess_country_prompt = /** @type {(inputs: Game_Guess_Country_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Угадайте выделенную страну.`)
};

const sv_game_guess_country_prompt = /** @type {(inputs: Game_Guess_Country_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gissa det markerade landet.`)
};

const tr_game_guess_country_prompt = /** @type {(inputs: Game_Guess_Country_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vurgulanan ülkeyi tahmin edin.`)
};

const uk_game_guess_country_prompt = /** @type {(inputs: Game_Guess_Country_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відгадайте виділену країну.`)
};

const vi_game_guess_country_prompt = /** @type {(inputs: Game_Guess_Country_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đoán đất nước được đánh dấu.`)
};

const zh_game_guess_country_prompt = /** @type {(inputs: Game_Guess_Country_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`猜猜突出显示的国家/地区。`)
};

const zh_hant_game_guess_country_prompt = /** @type {(inputs: Game_Guess_Country_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`猜猜突出顯示的國家。`)
};

/**
* | output |
* | --- |
* | "Guess the highlighted country." |
*
* @param {Game_Guess_Country_PromptInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_guess_country_prompt = /** @type {((inputs?: Game_Guess_Country_PromptInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Guess_Country_PromptInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_guess_country_prompt(inputs)
	if (locale === "de") return de_game_guess_country_prompt(inputs)
	if (locale === "el") return el_game_guess_country_prompt(inputs)
	if (locale === "en") return en_game_guess_country_prompt(inputs)
	if (locale === "es") return es_game_guess_country_prompt(inputs)
	if (locale === "fr") return fr_game_guess_country_prompt(inputs)
	if (locale === "hi") return hi_game_guess_country_prompt(inputs)
	if (locale === "hu") return hu_game_guess_country_prompt(inputs)
	if (locale === "id") return id_game_guess_country_prompt(inputs)
	if (locale === "it") return it_game_guess_country_prompt(inputs)
	if (locale === "ja") return ja_game_guess_country_prompt(inputs)
	if (locale === "ko") return ko_game_guess_country_prompt(inputs)
	if (locale === "nl") return nl_game_guess_country_prompt(inputs)
	if (locale === "pl") return pl_game_guess_country_prompt(inputs)
	if (locale === "pt") return pt_game_guess_country_prompt(inputs)
	if (locale === "ru") return ru_game_guess_country_prompt(inputs)
	if (locale === "sv") return sv_game_guess_country_prompt(inputs)
	if (locale === "tr") return tr_game_guess_country_prompt(inputs)
	if (locale === "uk") return uk_game_guess_country_prompt(inputs)
	if (locale === "vi") return vi_game_guess_country_prompt(inputs)
	if (locale === "zh") return zh_game_guess_country_prompt(inputs)
	return zh_hant_game_guess_country_prompt(inputs)
});